import type { TonyteActivity } from '../types';
import { isActivityCurrentOrUpcoming } from './activityDates';

// Statuses that mean "not live". A denylist rather than `status === 'approved'`
// because stored data isn't uniform (curated/imported events may carry no status
// at all, and useFeed defaults a missing one to 'approved') — an allowlist would
// silently empty the carousels if a live event carried any other value.
const UNAVAILABLE_STATUSES = new Set([
  'rejected', 'pending', 'cancelled', 'canceled', 'draft', 'unpublished', 'archived', 'deleted',
]);

// Hard availability gate shared by every discovery carousel (Featured This
// Week, Top Picks for You). The regular feed pool is already filtered to
// approved / non-private / role-visible events by useFeed, but that filter runs
// at fetch time — a carousel can outlive it (an event ends, or is cancelled by
// a later cache update), so each carousel re-checks with a live `now`.
export function isEventAvailableForDiscovery(activity: TonyteActivity, now: Date = new Date()): boolean {
  if (activity.deleted === true || activity.expired === true) return false;
  if (activity.approved === false) return false;
  if (activity.status && UNAVAILABLE_STATUSES.has(String(activity.status).toLowerCase())) return false;
  if (activity.visibility === 'private') return false;
  return isActivityCurrentOrUpcoming(activity, now);
}
